<div class="flex-container">
  <div>
    <div class="tag">
      <mat-icon>lock_outline</mat-icon
      >{{ 'setUpTwoFactor.required' | translate }}
    </div>
    <h3>{{ 'setUpTwoFactor.title' | translate }}</h3>
  </div>
  <img
    ngSrc="../../../assets/images/mfa-initial.png"
    width="221"
    height="110"
    [alt]="'setUpTwoFactor.setUpMfa' | translate"
    class="illustration"
  />
</div>
<h4 class="bold">{{ 'setUpTwoFactor.text' | translate }}</h4>
<div class="bullet">
  <p>
    <mat-icon>check</mat-icon>
    {{ 'setUpTwoFactor.bullet1' | translate }}
  </p>
</div>
<div class="bullet">
  <p>
    <mat-icon>check</mat-icon>
    {{ 'setUpTwoFactor.bullet2' | translate }}
  </p>
</div>
<div class="button-container">
  <button
    mat-stroked-button
    class="cancel-button"
    type="submit"
    (click)="onDismiss()"
  >
    {{ 'setUpTwoFactor.remindMe' | translate }}
  </button>
  <button
    mat-flat-button
    class="submit-button"
    color="primary"
    type="submit"
    (click)="onSetUp()"
  >
    {{ 'setUpTwoFactor.setUp' | translate }}
  </button>
</div>
